export const languages = {
  en: 'الإنجليزية',
  fr: 'الفرنسية',
  es: 'الإسبانية',
  zh: 'الصينية',
  ja: 'اليابانية',
  ar: 'العربية'
};